import * as React from "react";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";

export const NewsletterDescription = ({ settings }) => {
    const alignmentClass = `text-${settings.content_alignment}`;
    
    // Parse the description from richtext if needed
    const descriptionText = settings.description_text?.replace(/<[^>]*>/g, '') || '';
    
    return (
        <div className={`newsletter-signup__description mt-2 mb-4 ${alignmentClass}`}>
            <Paragraph 
                text={descriptionText} 
                type={settings.text_style || 'b2'} 
            />
        </div>
    );
};

export default NewsletterDescription;